export function PostData(type, userData) {


    let BaseURL = `http://35.154.224.75:1338/user/`;
    //let BaseURL = 'http://35.154.224.75:1337/user/login/';
    
    console.log("JSON FORMAT DATA+++++++++++++++",JSON.stringify(userData))
    var promise1 =  new Promise((resolve, reject) =>{
          fetch(BaseURL+type, {
               method: 'POST',
               body: JSON.stringify(userData)
               })
               .then((response) => response.json())
               .then((res) => {
                console.log("rrrrrrrr",res);
                resolve(res);
               })
               .catch((error) => {
                console.log("NOOTAN", error);
                resolve({error: "Sorry, Something went wrong. Please try again!!"});
                });
         });
    return promise1;
}


   


// WEBPACK FOOTER //
// ./Service/PostData.js